import { MessageCircle, ArrowRight, ShieldCheck } from "lucide-react";
import { BRAND } from "@/data/content";
import { StarDash } from "@/components/StarDash";

const Hero = () => {
  const waLink = `${BRAND.whatsapp}?text=${BRAND.whatsappText}`;
  const scrollContact = () =>
    document.querySelector("#contact")?.scrollIntoView({ behavior: "smooth" });

  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative pt-28 pb-14 sm:pt-40 sm:pb-24 bg-[#f5ede1] grain overflow-hidden"
    >
      <div className="max-w-5xl mx-auto px-5 sm:px-6 md:px-10 relative text-center">
        <StarDash className="mb-8 sm:mb-10" />

        <div className="font-sans-body text-[11px] font-bold uppercase tracking-[0.32em] text-[#6b5a4a]">
          Est. 2005 · Kuala Lumpur
        </div>

        <h1
          className="font-display mt-6 text-[68px] sm:text-[120px] lg:text-[180px] font-bold leading-[0.86] tracking-[-0.04em] text-[#c63027]"
          data-testid="hero-headline"
        >
          INC.
        </h1>
        <div className="mt-3 font-sans-body text-xs sm:text-base font-semibold uppercase tracking-[0.32em] sm:tracking-[0.42em] text-[#6b5a4a]">
          Cleaning Services
        </div>
        <div className="mt-6 mx-auto w-16 h-[2px] bg-[#c63027]" />

        <p className="font-italic-serif mt-9 text-[28px] sm:text-5xl lg:text-6xl text-[#2b1a14] leading-[1.1]">
          We Don't Cut Corners,
          <br />
          <span className="text-[#c63027]">We Clean Them.</span>
        </p>

        <p className="mt-7 max-w-2xl mx-auto text-base sm:text-xl text-[#5a4636] leading-relaxed">
          Home · Office · Commercial cleaning across Kuala Lumpur — by a
          bonded, trained team serving customers for two decades.
        </p>

        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href={waLink}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="hero-whatsapp-btn"
            className="pill-btn w-full sm:w-auto inline-flex items-center justify-center gap-2 h-14 px-8 bg-[#25D366] hover:bg-[#1ebe5b] text-white text-base transition-colors shadow-md"
          >
            <MessageCircle className="size-5" />
            WhatsApp
          </a>
          <button
            onClick={scrollContact}
            data-testid="hero-quote-btn"
            className="pill-btn w-full sm:w-auto group inline-flex items-center justify-center gap-2 h-14 px-8 bg-[#c63027] hover:bg-[#a8231b] text-[#fbf3e6] text-base transition-colors shadow-md"
          >
            Request a Free Quote
            <ArrowRight className="size-5 group-hover:translate-x-1 transition-transform" />
          </button>
        </div>

        <StarDash className="mt-14" />

        <div className="mt-8 inline-flex flex-wrap max-w-full items-center justify-center gap-x-3 sm:gap-x-6 gap-y-2 px-4 sm:px-6 py-3 bg-[#c63027] text-[#fbf3e6]">
          <span className="font-sans-body text-[10px] sm:text-[11px] font-bold uppercase tracking-[0.22em] sm:tracking-[0.28em]">
            ★ Home
          </span>
          <span className="opacity-50">·</span>
          <span className="font-sans-body text-[10px] sm:text-[11px] font-bold uppercase tracking-[0.22em] sm:tracking-[0.28em]">
            ★ Office
          </span>
          <span className="opacity-50">·</span>
          <span className="font-sans-body text-[10px] sm:text-[11px] font-bold uppercase tracking-[0.22em] sm:tracking-[0.28em]">
            ★ Commercial
          </span>
          <span className="opacity-50 hidden sm:inline">—</span>
          <span className="hidden sm:inline font-sans-body text-[10px] sm:text-[11px] font-bold uppercase tracking-[0.22em] sm:tracking-[0.28em]">
            21+ Years Trusted
          </span>
        </div>

        <div className="mt-10 flex flex-wrap items-center justify-center gap-x-8 gap-y-3 text-sm text-[#6b5a4a]">
          <div className="inline-flex items-center gap-2">
            <ShieldCheck className="size-4 text-[#c63027]" />
            <span className="font-sans-body font-semibold text-[#3b2a1f]">
              Bonded & Insured
            </span>
          </div>
          <div className="inline-flex items-center gap-2 font-italic-serif">
            <span>Satisfaction Guaranteed</span>
          </div>
          <div className="inline-flex items-center gap-2 font-sans-body text-xs uppercase tracking-[0.22em]">
            <span className="size-1.5 bg-[#c63027]" />
            Reg. 001581631-H
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
